<template>
  <v-container id="subscribe" tag="section">
    <base-card color="rgba(203, 170, 92, 0.51)" class="pa-3">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d10129.15470030957!2d28.866767558530537!3d40.99427077733856!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cabbb49f2e952f%3A0x5247ac38b0d7429e!2zQVNGQVJNQSBNRUTEsEtBTCBERU5UQUwgw5xSw5xOTEVSIFZFIMSwTEHDhyBTQU5BWcSwIFTEsENBUkVUIEFOT07EsE0gxZ7EsFJLRVTEsA!5e0!3m2!1str!2str!4v1529677555534"
        width="100%"
        height="450"
        frameborder="0"
        style="border:0"
        allowfullscreen
      ></iframe>
      <v-container grid-list-xl align-center>
        <v-layout wrap>
          <v-flex xs12 style="text-align:center">
            <h1>Headquarters</h1>
            <div>
              <table cellpadding="0" cellspacing="0" width="100%" style="text-align:center">
                <tr height="20">
                  <td colspan="3">
                    <h1>TURKEY</h1>
                  </td>
                </tr>

                <tr height="9">
                  <td height="9">&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                </tr>
                <tr height="20">
                  <td
                    height="20"
                    colspan="3"
                  >Kadir Has Center İşmerkezi, Ressam Halim Sk. No: 7/32, 34180 Bahçelievler, Istanbul Turkey</td>
                </tr>
                <tr height="20">
                  <td height="20" colspan="3">Tel : (+90 212) 441 40 01</td>
                </tr>
                <tr height="20">
                  <td height="20" colspan="3">Email: info@asfarma.com</td>
                </tr>
                <tr>
                  <td colspan="3">&nbsp;</td>
                </tr>
              </table>
            </div>
            <hr>
            <h1 class="contact-page" style="text-align:center">Offices</h1>
            <v-container grid-list-md text-xs-center>
              <v-layout row wrap>
                <v-flex xs2>
                  <v-card dark color="light-green" style="height:170px">
                    <v-card-text class="px-0">
                      <h1>AZERBAIJAN</h1>
                      <div>
                        <p>Ataturk Ave. 126, Neriman Nerimanov district, AZ1069 Baku</p>
                        <span>Tel : +994 124401183</span>
                        <br>
                        <span>Fax: +994 124401243</span>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs2>
                  <v-card dark color="indigo" style="height:170px">
                    <v-card-text class="px-0">
                      <h1>GEORGIA</h1>
                      <div>
                        <p>Metekhi str.22, Tbilisi, Georgia, 0103</p>
                        <span>Tel : +995 322273397</span>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs2>
                  <v-card dark color="purple" style="height:170px">
                    <v-card-text class="px-0">
                      <h1>MOLDOVA</h1>
                      <div>
                        <p>Mun. Chisinau, bd. Moscovei 17/4</p>
                        <p>Tel : +37 322000638</p>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs2>
                  <v-card dark color="red" style="height:170px">
                    <v-card-text class="px-0">
                      <h1>RUSSIA</h1>
                      <div>
                        <p>125167 Moscow city , 8 Mart street. No:6a</p>
                        <p>Tel : +74959872090</p>
                        <p>Tel2: +78435549154</p>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs2>
                  <v-card dark color="teal" style="height:170px">
                    <v-card-text class="px-0">
                      <h1>UZBEKISTAN</h1>
                      <div>
                        <p>Mirzo Ulugbek region, Katta Darxon street 15, Tashkent</p>
                        <p>Tel : +998712351706</p>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs2>
                  <v-card dark color="orange" style="height:170px">
                    <v-card-text class="px-0">
                      <h1>KAZAKHISTAN</h1>
                      <div>
                        <p>Karmısova Srteet, No:90 Almatı</p>
                        <p>Tel : +77272913147</p>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
        </v-layout>
      </v-container>
    </base-card>
  </v-container>
</template>

<script>
export default {
  components: {}
};
</script>
